// removed by extract-text-webpack-plugin
module.exports = {"report-types-grid":"src-components----ReportTypesGrid-module---report-types-grid---1AH0f","cell":"src-components----ReportTypesGrid-module---cell---3RBWE","heading":"src-components----ReportTypesGrid-module---heading---2Gs_r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportTypesGrid.module.scss
// module id = 661
// module chunks = 173911521112049